import
{
    Component,
    OnInit
}
    from '@angular/core';
import
{
    GlobalsService
}
    from '../globals.service';
import
{
    Router
}
    from '@angular/router';

import
{
    Howl,
    Howler
}
    from 'howler';

import * as moment from 'moment';
import { MapViewComponent } from '../components/mapview/mapview.component';

@Component(
    {
        selector: 'app-main',
        templateUrl: './main.component.html',
        styleUrls: ['./main.component.css']
    })

export class MainComponent implements OnInit
{


    constructor(private globals: GlobalsService, private router: Router)
    {

    }

    ngOnInit()
    {

    }



}